export const REDUX_NAMESPACE = 'app/sso/';
export const REDUXACTIONS_STRUCTURE = { openFreshdesk: null };
